export default "__VITE_ASSET__d51e4e49__"